<template>
  <div>
    <div
      class="category"
      v-for="(category, index) in categories"
      v-bind:key="index"
    >
      <router-link
        :to="{ name: 'ViewCategory', params: { categoryId: category.id } }"
        class="category-wrap"
      >
        <div class="name">
          <i class="fad fa-folder"></i>
          <p>{{ category.name }}</p>
        </div>
        <div class="number-items">
          <p>{{ category.items }}</p>
        </div>
        <div class="date">
          <p>{{ category.datemod.toDateString() }}</p>
        </div>
        <div class="created-by">
          <p>{{ category.createdby }}</p>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "Categorys",
  props: ["categories"],
  methods: {},
};
</script>

<style lang="scss" scoped></style>
